function Overlays(options) {
    this.defaults = {
    	closeOnClickOutside: true,
    };
    $.extend(this, this.defaults, options);
	this.init();
}

Overlays.prototype.init = function() {
	var self = this;
	self.closeOverlays();
	$('.section--imagebox-6').on('click', function(e) {
		e.preventDefault();
		var link = $(this).find('div[data-link]').attr('data-link');
		console.log(link);
		if (link.includes('soundcloud')) {console.log('sc');
			$('.soundcloud-overlay iframe').attr('src', link);
			self.showOverlay($('.soundcloud-overlay'));
			$('html').removeClass('active-overlay');
		}
		if (link.includes('youtu')) {console.log('yt');
			$('.youtube-overlay iframe').attr('src', link);
			self.showOverlay($('.youtube-overlay'));
		}
	});
};

Overlays.prototype.showOverlay = function(target) {
	var self = this;
	this.hideOverlay($('.body-overlay--active'));
	target.addClass('body-overlay--active');
	$('html').addClass('active-overlay');
};

Overlays.prototype.hideOverlay = function(target) {
	var self = this;
	target.removeClass('body-overlay--active');
	$('html').removeClass('active-overlay');
	if (target.hasClass('-go-home') || target.hasClass('-new-client')) {
		window.location.href = '/';
	}
};

Overlays.prototype.closeOverlays = function() {
	var self = this;

	// zamykanie klikajac obok okna
	if (self.closeOnClickOutside) {
		$('body').on('click', '.body-overlay--active .body-overlay-wrapper', function(e) {
			e.stopPropagation();
		});
		$('body').on('click', '.body-overlay--active', function(e) {
			self.hideOverlay($(this));
		});
	}

	// zamykanie przyciskiem
	$('.body-overlay-wrapper').on('click', '.body-overlay__close', function(e) {
		e.stopPropagation();
		self.hideOverlay($(this).closest('.body-overlay'));
	});
};